import {useEffect, useRef} from "react"

export function AbortWrapper() {
    const abortComponent = useRef([])

    const createAbort = () => {
        const controller = new AbortController()
        abortComponent.current.push(controller)

        return controller
    }

    const abortAll = () => {
        abortComponent.current.map((controller) => {
            controller.abort()
        })
    }

    useEffect(() => {
        return () => {
            abortAll()
        }
    }, [])

    return {
        createAbort,
        abortAll
    }
}
